import React from 'react';
type FillSliderProps = {
  ariaLabel: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
};
export function FillSlider({
  ariaLabel,
  value,
  min,
  max,
  step,
  onChange
}: FillSliderProps) {
  const pct = (value - min) / (max - min);
  return <div className="relative h-[16px] min-w-0 flex-1" data-id="element-842" data-mp="323fvjvwnwsgc">
      <div className="absolute inset-x-0 top-1/2 h-[5px] -translate-y-1/2 rounded-full bg-[#e3e5e8]" data-id="element-843" data-mp="3224qztve7go6" />
      <div className="absolute left-0 top-1/2 h-[5px] -translate-y-1/2 rounded-full bg-pf-blue" style={{
      width: `calc(${pct} * (100% - 14px) + 7px)`
    }} data-id="element-844" data-mp="2n9bcaany34kk" />
      <input aria-label={ariaLabel} type="range" min={min} max={max} step={step} value={value} onChange={e => onChange(Number(e.target.value))} className="pf-range-plain absolute inset-0 h-full w-full" data-id="element-845" data-mp="2e7btpdxa7sfi" />
      
    </div>;
}